import React, { Fragment, useEffect, useState } from 'react';
import './../Resources/css/block_foodmenu.css'

import Common from '../../../Shared/Common';
import Block from '../../../Controls/Scafolding/Block';

import { Row, Col } from 'reactstrap';
import { TextHeader, TextTitle, TextBock } from '../../../Controls/Digital/TextHeaders';

import foodMenuHeader from '../Resources/Images/FoodMenu/header.jpg';
import foodMenuPage1 from '../Resources/Images/FoodMenu/Page-1.jpg';
import foodMenuPage2 from '../Resources/Images/FoodMenu/Page-2.jpg';
import foodMenuPage3 from '../Resources/Images/FoodMenu/Page-3.jpg';
import { DownloadMenuButton } from '../Components/DownloadMenuButton';

const FoodMenu = (props) =>{

    const [blockName, setBlockName] = useState("");

    useEffect(() => {
        setBlockName(props.name);
        Common.traceInit("Block " + blockName);
    });

    return (
        <Block name="foodmenu" isAlt={true}>

            <Row>
                <Col lg="12" className="menu-page">
                    <img src={foodMenuHeader} className="img-fluid" />
                </Col>
            </Row>

            <Row>
                <Col lg="12" className="menu-page">
                    <img src={foodMenuPage1} className="img-fluid" />
                </Col>
            </Row>

            <Row>
                <Col lg="12" className="menu-page">
                    <img src={foodMenuPage2} className="img-fluid" />
                </Col>
            </Row>

            <Row>
                <Col lg="12" className="menu-page">
                    <img src={foodMenuPage3} className="img-fluid" />
                </Col>
            </Row>

            <Row>
                <Col lg="12" className="text-center">
                    <div className="download-menu">
                        <DownloadMenuButton />
                    </div>
                </Col>
            </Row>

        </Block>
    );
}
export default FoodMenu;
